/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
export async function update(tableName, requestBody) {

    try {
        const url = process.env.REACT_APP_API_URL + "update/"
        const request = {
            method: "PATCH",
            body: JSON.stringify(requestBody)
        }
        let path;
        switch (tableName) {
            case "EFFECTIVITY":
                path = "effectivity"
                break
            case "PARTS":
                path = "part"
                break
            case "PRINTERS":
                path = "printer"
                break
            default:
                throw new Error("BAD ENDPOINT");
        }
        const response = await fetch(url + path, request);
        const json = await response.json();
        if (json.statusCode !== 200) {
            throw new Error("STATUS: " + json.statusCode);
        }
        return json;
    } catch (error) {
        return {
            statusCode: 500,
            body: {
                message: error.message
            }
        }
    }
}
